import Swal from "sweetalert2";

export const SwalAlert = Swal.mixin({
    showCancelButton: true,
    reverseButtons: true,
    buttonsStyling: false,
    focusConfirm: false,
    customClass: {
        confirmButton: 'btn w-50',
        cancelButton: 'btn btn-secondary btn-block mr-3 w-50',
        denyButton: 'btn btn-secondary btn-block mr-3 w-50',
        actions: 'flex-nowrap',
    },
})

export const Toast = Swal.mixin({
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
    toast: true,
    position: 'top',
    showCancelButton: true,
    cancelButtonColor: '',
    cancelButtonText: 'Okay',
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})